import React from "react";
import "./Header.scss";
import { Link, Stack } from "@mui/material";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { Container } from "@mui/system";

function Header() {

  return (
    <header className="App-header">
      <Container>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="header-stack"
      >
        <Link href="/">
        <img src={process.env.PUBLIC_URL + '/TotalEnergies.svg'} className="App-logo" alt="logo" /></Link>
        <LanguageSelector />
      </Stack>
      </Container>
    </header>
  );
}

export default Header;
